module.exports = __webpack_public_path__ + "static/media/canExplore.46bccbc4.png";